package addedittravelagent

import androidx.compose.runtime.Composable
import androidx.compose.ui.platform.LocalUriHandler
import com.essntl.features.itinerary.domain.model.ItineraryModel
import com.essntl.features.itinerary.domain.model.shareLink
import com.essntl.features.proposal.domain.model.ProposalModel
import com.essntl.features.proposal.domain.model.shareLink
import com.essntl.uikit.components.card.EsExpandableCardsSection
import com.essntl.uikit.components.iconbutton.outline.EsSmallOutlineIconButton
import com.essntl.uikit.components.iconbutton.primary.EsSmallPrimaryIconButton
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.rememberNumberOfDaysPrettyString
import core.dateformat.ui.formatDateRange


@Composable
fun ProposalsAndItinerariesSection(
    proposals: List<ProposalModel>,
    itineraries: List<ItineraryModel>,
    onEditProposalClicked: (String) -> Unit,
    onEditItineraryClicked: (String) -> Unit,
) {
    val uriHandler = LocalUriHandler.current

    if (proposals.isNotEmpty()) {
        EsExpandableCardsSection(
            items = proposals,
            title = "Proposals",
            cardTitle = { it.title ?: "" },
            cardSubtitle = {
                listOf(
                    it.fromDate,
                    it.toDate,
                ).formatDateRange() + '\n' + rememberNumberOfDaysPrettyString(
                    it.fromDate,
                    it.toDate,
                )
            },
            cardActionButtons = {
                EsSmallOutlineIconButton(
                    onClick = {
                        uriHandler.openUri(
                            uri = it.shareLink,
                        )
                    },
                    iconRes = EsIcons.Browse,
                )

                EsSmallPrimaryIconButton(
                    onClick = {
                        onEditProposalClicked(it.id)
                    },
                    iconRes = EsIcons.Edit,
                )
            },
        )
    }

    if (itineraries.isNotEmpty()) {
        EsExpandableCardsSection(
            items = itineraries,
            title = "Itineraries",
            cardTitle = { it.proposal?.title ?: "" },
            cardSubtitle = {
                listOf(
                    it.proposal?.fromDate,
                    it.proposal?.toDate,
                ).formatDateRange() + '\n' + rememberNumberOfDaysPrettyString(
                    it.proposal?.fromDate,
                    it.proposal?.toDate,
                )
            },
            cardActionButtons = {
                EsSmallOutlineIconButton(
                    onClick = {
                        it.shareLink?.let { link ->
                            uriHandler.openUri(
                                uri = link,
                            )
                        }
                    },
                    iconRes = EsIcons.Browse,
                )

                EsSmallPrimaryIconButton(
                    onClick = {
                        onEditItineraryClicked(it.id)
                    },
                    iconRes = EsIcons.Edit,
                )
            },
        )
    }
}